import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import { getCategories, updateCategory, deleteCategory, uploadCategoryImage } from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import { showSuccessToastMessage, showErrorToastMessage } from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import { emptyCheck } from "../../../../utilities";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";
// import * as CONSTANT from "../../../../constants";

class AdminCategories extends Component {
  state = {
    moduleid: 0,
    mastercategories: [],
    categories: [],
    selectedCategory: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getCategoriesFromService();
  }

  getModuleId() {
    return parseInt(this.props.match.params.moduleid, 10);
  }

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getCategoriesFromService() {
    this.showSpinner(true);
    getCategories(this.getModuleId())
      .then(response => {
        this.setState({ categories: response.data, mastercategories: response.data });
        this.showSpinner(false);
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }

  editCategory(category) {
    this.setState({
      action: "edit",
      selectedCategory: category,
      showModal: true,
      errorMessage: ""
    });
  }

  deleteCategory(category) {
    this.setState({
      action: "delete",
      selectedCategory: category,
      showDeleteModal: true
    });
  }

  addCategory() {
    this.setState({
      action: "add",
      selectedCategory: {},
      showModal: true,
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "Category");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }

  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }
  updateCategoryService(data) {
    updateCategory(data)
      .then(response => {
        this.showSpinner(false);
        console.log(response);
        this.onHideModal();
        this.showSuccessMessage(data.Name);
        this.getCategoriesFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
        this.onHideModal();
      });
  }
  saveCategory() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedCategory.Id : 0,
      Tid: this.state.action === "edit" ? this.state.selectedCategory.Tid : 0,
      Name: this.refs["txtCategory"].value,
      Description: this.refs["txtCategoryDescription"].value,
      ImagePath: this.state.action === "edit" ? this.state.selectedCategory.ImagePath : "",
      ModuleId: this.getModuleId()
    };
    const uploadedFile = document.getElementById("file");
    if (this.validate(data)) {
      switch (this.state.action) {
        case "edit":
          this.showSpinner(true);
          if (uploadedFile.files.length > 0) {
            let formdata = new FormData();
            formdata.append("file", uploadedFile.files[0]);
            uploadCategoryImage(formdata)
              .then(resFilePath => {
                data.OldImagePath = data.ImagePath;
                data.ImagePath = resFilePath.data;
                console.log(resFilePath);
                this.updateCategoryService(data);
              })
              .catch(error => {
                this.showSpinner(false);
                this.showErrorMessage(error);
                console.log(error);
              });
          } else {
            this.updateCategoryService(data);
          }

          break;
        default:
          break;
      }
    }
  }

  confirmDeleteCategory() {
    this.showSpinner(true);
    deleteCategory(this.state.selectedCategory.Id)
      .then(response => {
        this.showSpinner(false);
        console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedCategory.Name);
        this.getCategoriesFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleCategoryChange = event => {
    let selectedCategory = this.state.selectedCategory;
    selectedCategory.Name = event.target.value;
    this.setState({ selectedCategory: selectedCategory });
  };

  goToCategories(value) {
    if (value.Name === "Learning" || value.Name === "学习") {
      this.props.history.push(`/admin/${this.getModuleId()}/${value.Id}/learningcategories/`);
    } else if (value.Name === "Workflow" || value.Name === "工作流程") {
      this.props.history.push(`/admin/${this.getModuleId()}/${value.Id}/workflowcategories/`);
    }
  }

  handleSearchTermChange = event => {
    let filteredCategories = this.state.mastercategories.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        categories: filteredCategories,
        searchTerm: event.target.value
      });
    else
      this.setState({
        categories: this.state.mastercategories,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Categories</h1>
        <AdminBreadcrumb
          data={[
            { name: "Home", link: "/admin/modules/" },
            { name: "Modules", link: "/admin/modules/" },
            { name: "Categories" }
          ]}
        />
        <Grid
          headers={["#", "Name"]}
          values={this.state.categories}
          indexName="Id"
          properties={["Id", "Name", "Action"]}
          edit={value => this.editCategory(value)}
          hideDelete="true"
          extraActions={[value => this.goToCategories(value)]}
          extraActionNames={["Manage"]}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveCategory()}
          form={this.addeditform}
          type="category"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              disabled="disabled"
              minLength="3"
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtCategory"
              defaultValue={this.state.selectedCategory.Name}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Description:
            </label>
            <input
              minLength="3"
              maxLength="100"
              type="text"
              className="form-control"
              ref="txtCategoryDescription"
              defaultValue={this.state.selectedCategory.Description}
            />
          </div>
          {/* <div className="form-group">
            <label>
              <RequiredField />
              Image (must be of size 1000 x 987 px):
            </label>
            <input id="file" type="file" className="form-control" ref="fileSubCategory" />
          </div> */}
          {/* {this.state.action === "edit" && (
            <div>
              <img
                width="300px"
                src={CONSTANT.API_BASE_URL + this.state.selectedCategory.ImagePath}
                alt="categoryimage"
              />
            </div>
          )} */}
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedCategory.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteCategory()}
          name={this.state.selectedCategory.Name}
          type="category"
        />
      </Aux>
    );
  }
}

export default AdminCategories;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Categories/Categories.js